import React, { Component } from 'react'

export default class Wait extends Component {
    render() {
        return (
            <div>
                <h1>Wait Page</h1>
            </div>
        )
    }
}
